export const UserNotConfirmedException = 'UserNotConfirmedException';



// WEBPACK FOOTER //
// ./constants/AmazonCodes.js